import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as myGlobals from 'src/app/globals';
import { HttpResponseModel } from 'src/app/models/response.model';
import { EmptyDocumentModel, TemplateCategoryModel } from 'src/app/models/template.model';
@Injectable()
export class DocumentTemplateService {
  constructor(private http: HttpClient) {}
  loadTemplates(): any {
    const url = `${myGlobals.Config.API}/documents/templates-categories`;

    return this.http.get<HttpResponseModel<TemplateCategoryModel[]>>(url);
  }

  loadTemplateChilds(): any {
    const url = `${myGlobals.Config.API}/documents/templates`;

    return this.http.get<HttpResponseModel<EmptyDocumentModel[]>>(url);
  }
}
